<template>
  <div class="row">
    <br />
    <br />
    <br />

    <div class="student">
      <p>Full Name : {{ student.fullName }}</p>
      <p>Email &nbsp; &nbsp; : {{ student.email }}</p>
      <p>
        Level &nbsp; &nbsp; : {{ student.level }}
        <span v-if="done" class="green-text">&nbsp;(done)</span>
      </p>
      <p>Lesson &nbsp; &nbsp;: {{ student.lesson }}</p>
      <p>Phone &nbsp; &nbsp; : {{ student.phone }}</p>
    </div>

    <br />

    <div class="card hoverable">
      <div class="card-content">
        <h5 v-if="studies === false" class="center red-text">No studies yet</h5>
        <div v-else class="switch">
          <label>
            Total
            <input type="checkbox" value="detail" v-model="filter" />
            <span class="lever"></span>
            Detail
          </label>
        </div>
      </div>
      <table v-if="studies.length" class="highlight responsive-table centered">
        <thead>
          <tr>
            <th>Level</th>
            <th>{{ filter.length ? 'Lesson' : 'Total Study'}}</th>
            <th v-if="filter.length">When</th>
            <th v-if="filter.length">How Long</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="study in  !filter.length ? totalStudies : studies" :key="study._id">
            <td v-if="filter.length">{{ study.level }}</td>
            <td v-else>{{ Object.keys(study)[0] }}</td>
            <td v-if="filter.length">{{ study.name }}</td>
            <td v-else>{{ study[Object.keys(study)[0]] }}</td>
            <td v-if="filter.length">{{ study.when }}</td>
            <td v-if="filter.length">{{ study.howLong }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <br />
    <br />
    <br />
  </div>
</template>


<script>
export default {
  data() {
    return {
      student: {},
      filter: [],
      studies: [],
      totalStudies: [],
      done: null
    };
  },
  created() {
    this.$store.dispatch("getUser", this.$route.params.token).then(response => {
      this.student = response.data;

      this.$store
        .dispatch("info")
        .then(
          info =>
            (this.done =
              info.data[response.data.level - 1].lessons.length <
              response.data.lesson)
        );
    });

    this.$store
      .dispatch("getStudies", this.$route.params.student)
      .then(response => {
        this.studies = response.data.studies || false;
        this.totalStudies = response.data.totalStudies || [];
      });
  }
};
</script>


<style scoped>
.student {
  font-size: 17px;
  font-family: "Courier New", Courier, monospace;
  color: #312a2ade;
}
</style>


// WEBPACK FOOTER //
// src/views/Student.vue